import React, { useEffect, useRef } from 'react';
import ArticleCardBase from '../../Base';
import CardMedia from '../../../../CardMedia';
import { inheritChildStyle } from '../../../../../helpers/text';

import './styles.scss';

const PortraitSocialEmbedYoutube = ({ data, endCard }) => {
  const { backgroundColor, sectionTitle, caption, youtubeVideoId } = data;
  const embedURL = youtubeVideoId ? `//www.youtube.com/watch?v=${youtubeVideoId}` : null;
  const noTitle =
    sectionTitle === null && caption === null ? 'portrait-social-embed-youtube__no-title' : '';
  const captionTextRef = useRef();

  useEffect(() => {
    if (captionTextRef.current) {
      inheritChildStyle(captionTextRef.current, 'a', 'color');
    }
  }, []);

  return (
    <ArticleCardBase variation="portrait" accentColor1={backgroundColor} endCard={endCard}>
      <section className={`card-container portrait-social-embed-youtube ${noTitle}`}>
        <div
          className="portrait-social-embed-youtube__title"
          dangerouslySetInnerHTML={{ __html: sectionTitle }}
        />
        <div
          ref={captionTextRef}
          className="portrait-social-embed-youtube__caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        />
        {embedURL ? (
          <div className="portrait-social-embed-youtube__asset-wrapper">
            <CardMedia
              url={embedURL}
              mimeType="video"
              playing={false}
              isAutoplay={false}
              muted={false}
              mediaContainerClasses="portrait-social-embed-youtube__media-container"
              mediaClasses="portrait-social-embed-youtube__media"
            />
          </div>
        ) : null}
      </section>
    </ArticleCardBase>
  );
};

export default PortraitSocialEmbedYoutube;
